import { analyticsService } from "@core/service-container";
import { AnalyticsCategory } from "@domain/analytics/analytics-types";
import { Announcement } from "@domain/announcement/announcement";

export const sendAnnouncementDisplayEvent = (announcement: Announcement): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.ANNOUNCEMENT,
		action: "display",
		params: [announcement.title, 1, announcement.pages.length],
	});

export const sendAnnouncementNextSlideEvent = (announcement: Announcement, currentIndex: number): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.ANNOUNCEMENT,
		action: "nextSlide",
		params: [announcement.title, currentIndex + 2, announcement.pages.length],
	});

export const sendAnnouncementPreviousSlideEvent = (announcement: Announcement, currentIndex: number): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.ANNOUNCEMENT,
		action: "previousSlide",
		params: [announcement.title, currentIndex, announcement.pages.length],
	});

export const sendAnnouncementCloseEvent = (announcement: Announcement): void =>
	analyticsService.trackEvent({
		category: AnalyticsCategory.ANNOUNCEMENT,
		action: "closeWindow",
		params: [announcement.title],
	});
